import sample from "lodash/sample";
import times from "lodash/times";

const chars = (alphabet, length) => times(length, () => sample(alphabet)).join("");

// Both external ids belong to the tracking platform, not to this API — but the
// console has to be able to onboard a brand without one in hand, so each field
// opens prefilled with a fresh value and stays editable for when the real
// platform id is known.

// Shaped like the ids the platform issues: 24 hex characters, the first eight
// a second-resolution timestamp (6a79d04b5eceb7d70dba1907).
export const newBrandExtId = () => `${Math.floor(Date.now() / 1000).toString(16)}${chars("0123456789abcdef", 16)}`;

// And like the holder ids it issues: the `holder-` prefix over 16 digits — a
// 13-digit millisecond timestamp plus three random (holder-9991232152419021).
export const newHolderExtId = () => `holder-${Date.now()}${chars("0123456789", 3)}`;

// A brand's two logins are seeded in the same breath, so their ids land in the
// same millisecond and only those three random digits separate them — one pair
// in a thousand would otherwise come out identical. Draw again until they are
// not, rather than leave it to the odds.
export const newHolderExtIdPair = () => {
    const admin = newHolderExtId();
    let affiliate = newHolderExtId();
    while (affiliate === admin) affiliate = newHolderExtId();
    return { admin, affiliate };
};

// ─── Invoice ──────────────────────────────────────────────────────────────────
// Both of these identify the invoice outside this API — `invoice_number` is
// what a human reads, `ext_invoice_id` what the billing system filed it under.
// Prefilled so an invoice can be raised without inventing either, and both stay
// editable for when the real values are known.

// INV-<yyyymm>-<4 digits>, in the spirit of the sample's INV-HUL-180.
export const newInvoiceNumber = () => {
    const now = new Date();
    const month = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, "0")}`;
    return `INV-${month}-${chars("0123456789", 4)}`;
};

// 20 lowercase letters, matching the sample's ds532dareawasaskasdh.
export const newExtInvoiceId = () => chars("abcdefghijklmnopqrstuvwxyz0123456789", 20);
